import { bridgeService } from '@/services'
import { createMutationMixin } from '@/shared'
import { removeTypename, useQuery } from 'codefabrik-gui-vue/src/apollo'

export const useCreateBridge = (methodName) => createMutationMixin({
  name: methodName,
  service: [bridgeService.createBridge, 'bridges.saveSuccess'],
  onSuccess: navigateToManagePage
})

export function useBridge (name) {
  return {
    mixins: [
      useQuery({
        name: name,
        serviceFn: bridgeService.getBridge,
        variables () {
          return { input: { bridgeId: this.$route.params.id }}
        },
        mappingFunctions: {
          [name]: [(bridge) => removeTypename(bridge), () => {
          }]
        }
      })
    ]
  }
}

export const useEditBridge = (methodName) => createMutationMixin({
  name: methodName,
  service: [bridgeService.editBridge, 'bridges.saveSuccess'],
  mapInput (input) {
    return { id: this.$route.params.id, ...input }
  },
  onSuccess: navigateToManagePage
})

export const useDeleteBridge = (methodName) => createMutationMixin({
  name: methodName,
  service: [bridgeService.deleteBridge, 'bridges.deleteSuccess'],
  mapInput () {
    return { bridgeId: this.$route.params.id }
  },
  onSuccess: navigateToManagePage
})

function navigateToManagePage () {
  this.$router.push({ name: 'manage-bridges' })
}
